import { getUserPlatform } from "~/scripts/utils";

class CustomerFields extends window.HTMLElement {
  constructor() {
    super();

    // Track Customer Fields
    const $signupForm = document.querySelector('form[data-cf-form="OLtPGq"]');

    if (!$signupForm) return;

    $signupForm.addEventListener("cf:form_submitted", function (event) {
      const { formId, submissionData } = event.detail;
      // -> "a39Jk2", { first_name: 'John', last_name: 'Smith', ... }, <form data-cf-form="n89j3k">

      // Facebook
      window?.fbq("track", "CompleteRegistration");
      // Google
      window?.gtag("event", "sign_up", { method: "email" });
      // Mixpanel
      window?.mixpanel.track("signup", {
        $first_name: submissionData.first_name,
        $last_name: submissionData.last_name,
        $email: submissionData.email,
        $phone: submissionData.phone,
        referral: `${formId}`,
        platform: `${getUserPlatform()}`,
      });
      // Twiiter
      window?.twq("event", "tw-od7mn-od7mv", {
        status: "completed",
        description: "email",
        email_address: submissionData?.email,
      });
      // Taboola
      // window?._tfa.push({ notify: "event", name: "signup", id: 1564798 });
      // Tiktok
      window?.ttq.track("CompleteRegistration", {
        method: "email",
      });
      // Mobile Native
      window?.messageBridge.postMessage({
        type: "analytics",
        payload: {
          event: "signup",
          properties: {
            method: "email",
          },
        },
      });
    });
  }
}

window.customElements.define("customer-fields", CustomerFields);
